import React from "react";
import pp from "../../assets/files/privacy-policy.pdf";

const PoliciesBody = () => {
  return (
    <section className="section section-spacing-100">
      <div className="container">
        <div className="large">
          <div className="section-content width-600 margin-auto">
            <div className="safety">
              <h2>HOW WE TRACK AND ENSURE SAFE WORK PRACTICES</h2>
              <p>
                JMSTONE Logistic Limited recognizes the importance of managing
                occupational health and safety matters effectively as an
                integral part of its business operations. We undertake all
                practicable measures to create a safe and healthy work
                environment for our employees, contractors, clients, visitors,
                the community in which we operate, and any other person who may
                be affected by or business activities.
              </p>
              <p>
                As a requirement, we have established and are implementing an
                integrated Occupational Health and Safety, and Environmental
                Management System in accordance with ISO 45001:2018 Occupational
                Health and Safety Management System Standard, and ISO 14001:2018
                Environmental Management System standard.{" "}
              </p>
              <p>
                Utilizing the Plan-Do-Check Module, we are able to monitor our
                operations and ensure safe and sustainable work practices, and
                ensure continuous improvements by implementing corrective
                measures.{" "}
              </p>
              <p>
                Additionally, we communicate our policies, procedures and best
                practices to all our staff, visitors, contractors and
                stakeholders.{" "}
              </p>
              <p>
                We encourage our employees to report all incidents/accidents,
                unfair treatments, and we make them aware of their rights and
                responsibilities in regards to health and safety at work. We
                encourage feedbacks regarding health and safety from employees,
                contractors and stakeholders through an open communication
                channel, to identify any areas of improvements.{" "}
              </p>
            </div>
            <div className="policies-container flex">
              <div className="policy-card">
                <h2>PRIVACY POLICY</h2>
                <p>This is our Privacy Policy, Click "Download" to download</p>
                <a
                  href={pp}
                  className="button"
                  target="_blank"
                  rel="noopener noreferrer"
                  download
                >
                  Download
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PoliciesBody;
